import api from './api';

const BASE = '/licencias';

export const TIPOS_DOCUMENTO = [
    // La Licencia de Funcionamiento en general no vence (indefinida); el
    // Certificado ITSE sí tiene fecha de vencimiento real.
    { value: 'licencia_funcionamiento', label: 'Licencia de Funcionamiento', requiereFecha: false },
    { value: 'certificado_itse', label: 'Certificado ITSE', requiereFecha: true },
];

export const licenciasService = {
    listarAlmacenes: async () => {
        const response = await api.get(`${BASE}/almacenes`);
        return response.data.almacenes;
    },

    obtenerPorAlmacen: async (almacen) => {
        const response = await api.get(`${BASE}/${encodeURIComponent(almacen)}`);
        return response.data;
    },

    resumen: async () => {
        const response = await api.get(`${BASE}/resumen`);
        return response.data;
    },

    historial: async (almacen, tipoDocumento) => {
        const response = await api.get(`${BASE}/${encodeURIComponent(almacen)}/historial`, {
            params: { tipo_documento: tipoDocumento },
        });
        return response.data;
    },

    subirDocumento: async (almacen, tipoDocumento, fechaRenovacion, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const params = { tipo_documento: tipoDocumento };
        if (fechaRenovacion) params.fecha_renovacion = fechaRenovacion;
        const response = await api.post(`${BASE}/${encodeURIComponent(almacen)}/subir`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params,
        });
        return response.data;
    },
};
